import { Box, CircularProgress, Typography, useTheme } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { spinnerCircle, spinnerContainer } from "../../styles/loadingStyles";

const LoadingSpinner = () => {
  const { t } = useTranslation();
  const theme = useTheme();

  return (
    <Box role="status" aria-live="polite" sx={spinnerContainer(theme)}>
      <CircularProgress aria-label={t("loading")} sx={spinnerCircle(theme)} />
      <Typography variant="body1" component="span">
        {t("loading")}
      </Typography>
    </Box>
  );
};

export default LoadingSpinner;
